import { ReactNode } from 'react';
import { Box, Card, CardContent, Typography, Stack, Button, Skeleton } from '@mui/joy';

interface WidgetPanelProps {
  title: string;
  children: ReactNode;
  viewAllLink?: string;
  viewAllLabel?: string;
  onViewAll?: () => void;
  loading?: boolean;
  emptyMessage?: string;
  isEmpty?: boolean;
  action?: ReactNode;
}

export default function WidgetPanel({
  title,
  children,
  viewAllLink,
  viewAllLabel = 'View All',
  onViewAll,
  loading,
  emptyMessage = 'Nothing to show',
  isEmpty,
  action,
}: WidgetPanelProps) {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography level="title-lg">{title}</Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            {action}
            {(viewAllLink || onViewAll) && (
              <Button
                variant="plain"
                size="sm"
                component={viewAllLink ? 'a' : 'button'}
                {...(viewAllLink ? { href: viewAllLink } : { onClick: onViewAll })}
              >
                {viewAllLabel}
              </Button>
            )}
          </Stack>
        </Stack>
        {loading ? (
          <Stack spacing={1.5}>
            <Skeleton variant="rectangular" height={40} />
            <Skeleton variant="rectangular" height={40} />
            <Skeleton variant="rectangular" height={40} />
          </Stack>
        ) : isEmpty ? (
          <Box textAlign="center" py={4}>
            <Typography level="body-sm" color="neutral">
              {emptyMessage}
            </Typography>
          </Box>
        ) : (
          children
        )}
      </CardContent>
    </Card>
  );
}
